const pBase64 = (str: string) => {
  const strLength = str.length;

  let result = '';
  let idx = 0;
  let char = '';

  while (idx !== strLength) {
    char = str[idx];

    if (char === '-') {
      result += '+';
    } else if (char === '_') {
      result += '/';
    } else {
      result += char;
    }

    ++idx;
  }

  return result;
};

const pDecoded = (str: string) => {
  const strLength = str.length;

  let result = '';
  let idx = 0;

  while (idx !== strLength) {
    result += '%' + ('00' + str[idx].charCodeAt(0).toString(16)).slice(-2);
    ++idx;
  }

  return result;
};

export default (token: string) => {
  const idx = token.indexOf('.') + 1;
  const tokenPayload = token.slice(idx, token.indexOf('.', idx));
  const str = pDecoded(window.atob(pBase64(tokenPayload)));
  return JSON.parse(decodeURIComponent(str));
};
